import { serverRequest } from './index';

export const getTokenLogoUrl = async (address) => {
  const tokenLogoUrl = await serverRequest(`tokens/${address}/logo`);
  return tokenLogoUrl;
};

export const getTokenMetadata = async (tokenUri) => {
  const tokenLogoUrl = await serverRequest(`token/metadata?tokenUri=${tokenUri}`);
  return tokenLogoUrl;
};
